import { FiX } from "react-icons/fi";

export default function Modal({
  open,
  onClose,
  children,
  showClose = true, // Optional close button (defaults to false for clean alert style)
  title = null,      // Optional title
  maxWidth = "max-w-md", // Dynamic Tailwind width (e.g., max-w-sm, max-w-xl, max-w-2xl)
  className = "",
}) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-[#E6E6E6]/[56%]  transition-opacity"
      onClick={onClose}
    >

      <div
        className={`relative flex max-h-[85vh] w-full flex-col rounded-3xl bg-white p-6 shadow-2xl transition-all ${maxWidth} ${className}`}
        onClick={(e) => e.stopPropagation()} // Prevent click inside modal from closing it
      >
        {/* Optional Header / Close Button */}
        {(title || showClose) && (
          <div className="mb-4 flex items-center justify-between">
            {title ? (
              <h3 className="text-lg font-bold text-gray-800">{title}</h3>
            ) : (
              <div />
            )}

            {showClose && (
              <button
                type="button"
                onClick={onClose}
                className="rounded-full p-1.5 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-700"
              >
                <FiX className="h-5 w-5" />
              </button>
            )}
          </div>
        )}

        {/* Modal Scrollable Body */}
        <div className="overflow-y-auto scrollbar-none">
          {children}
        </div>
      </div>
    </div>
  );
}